<!--
This ensures that an input or textarea is always in focus,
which is necessary for copy and paste functionality
-->

<template>
  <input id="invisible-input" @blur="onBlur" />
</template>

<script>
var currentID = "";
var assignedIDs = { 0: false };

export default {
  name: "InvisibleInput",
  methods: {
    onBlur() {
      function keepAnInputSelected() {
        let activeElement = document.activeElement;
        if (
          activeElement.tagName == "INPUT" ||
          activeElement.tagName == "TEXTAREA" ||
          activeElement.tagName == "SELECT"
        ) {
          // this method is already the listener for invisible-input, so don't add a new one!
          if (activeElement.id == "invisible-input") {
            return;
          }
          // create an id for the element if it doesn't have one
          if (activeElement.id == "") {
            let assignedID = 0;
            while (!assignedIDs[assignedID]) {
              assignedID = Math.floor(Math.random() * Math.floor(1000000));
              if (!assignedIDs[assignedID]) {
                assignedIDs[assignedID] = true;
                activeElement.setAttribute("id", assignedID);
                break;
              }
            }
          }
          // add listener to the current element
          currentID = activeElement.id;
          //console.log("addListenerTo: " + currentID);
          activeElement.addEventListener("blur", KISS);
        } else {
          // reattach if blurred and another field is not grabbed
          //console.log("focusing on invisible-input");
          currentID = "";
          document.getElementById("invisible-input").focus();
        }
      }

      function KISS() {
        if (currentID != "invisible-input") {
          //console.log("removeListenerFrom: " + currentID);
          document.getElementById(currentID).removeEventListener("blur", KISS);
          setTimeout(function() {
            keepAnInputSelected();
          }, 0);
        }
      }
      setTimeout(keepAnInputSelected, 0);
    }
  },
  mounted() {
    document.getElementById("invisible-input").focus();
  }
};
</script>
